<template>
	<div
		id="attributeModal"
		style="display: block"
		class="modal user-restore-confirm-modal"
		role="dialog"
	>
		<div class="modal-backdrop" @click="$emit('close')"></div>
		<div class="modal-dialog" id="attributeInner">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="titleModal">Restore suspended user</h4>
					<b-button @click="$emit('close')">
						x
					</b-button>
				</div>
				<div class="modal-body">
					<Loading
						v-if="isLoading"
						:active.sync="isLoading"
						:is-full-page="false"
					/>
					<div v-else class="message">
						<span>Do you really want to restore</span>
						<span class="username">{{ restoringUserDetails.username }}?</span>
					</div>
				</div>
				<div class="modal-footer">
					<button class="theme-fill-btns" @click="$emit('submitUserRestore')">
						Restore
					</button>
					<button class="default-fill-btns" @click="$emit('close')">
						Cancel
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
	props: ["restoringUserDetails"],
	data() {
		return {
			isLoading: false
		};
	},
	components: {
		Loading
	},
	methods: {
		waitTwoMinutes() {
			return new Promise((resolve, reject) =>
				setTimeout(() => {
					return Math.random() > 0.5 ? resolve() : reject();
				}, 2000)
			);
		}
	}
};
</script>
